import { deserialize } from 'cerialize'
import { ProductShortInfoModal } from 'Models'

export class BlockingRulesModel {
	@deserialize public id: number
	@deserialize public name: string
	@deserialize public is_active: boolean
	@deserialize public allow_creator_duplicates: boolean
	@deserialize public product_ids: number[]
	@deserialize public created_at: string
	@deserialize public updated_at: string
	@deserialize public order_delay: number
	@deserialize public products: ProductShortInfoModal[]
}
